import { defineComponent } from 'vue';
import FloatingCard from '@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue';
import TimerConfirmationModal from '@/components/Shared/Modals/TimerConfirmationModal/TimerConfirmationModal.vue';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import { mapWritableState } from 'pinia';
import ThemesHelper from '@/helpers/ThemesHelper';
import AlertBox from '@/components/AlertBox/AlertBox.vue';

export default defineComponent({
  components: {
    FloatingCard,
    TimerConfirmationModal,
    AlertBox,
  },
  data() {
    return {
      StepContent: ThemesHelper.getThemeParams('testStepFiveContents'),
      registerTestStore: useRegisterTestStore(),
      hasError: false,
      results: {
        positive: {
          code: 'OIFpxJJdcT',
          result: 'positive',
        },
        negative: {
          code: 'lZHevGuasm',
          result: 'negative',
        },
        invalid_one_line: {
          code: 'dCVP65Sixs',
          result: 'invalid_one_line',
        },
        invalid_no_line: {
          code: 'y1e9A3Xt2z',
          result: 'invalid_no_line',
        },
      },
    };
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ['canJumpNext']),
  },
  methods: {
    setResultTest(value: any) {
      this.registerTestStore.resultTest = value.result;
      this.registerTestStore.resultTestCode = value.code;
      this.registerTestStore.canJumpNext = true;
      this.hasError = false;
    },
    errorValidation() {
      this.hasError = true;
      return false;
    },
    isValidStep(): boolean {
      return this.registerTestStore.resultTest != '';
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs['base-modal'];
        switch (animationName) {
          case 'setNextDismissAnimation':
            baseModal.setNextDismissAnimation();
            break;
          case 'setNextShowAnimation':
            baseModal.setNextShowAnimation();
            break;
          case 'setPreviousDismissAnimation':
            baseModal.setPreviousDismissAnimation();
            break;
          case 'setPreviousShowAnimation':
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    },
  },
});
